import React from "react";
// 	nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.

function validarNombre(validar) {
  if (/^[a-zA-ZÀ-ÿ\s]{1,30}$/i.test(validar)) {
    //alert("nombre " + validar + " es correcto!.");
    return "aceptadoNombre";
  } else {
    return "errorNombre";
  }
}

export default validarNombre;
